import config from '../../configs/config';
import { IReportGridPublicAccess } from '../../../../reportgrid/src/model';
import { makeApiGatewayCall, makeApiProxyGatewayCall } from '../common/apiUtils';

export interface IMetadataAttributes {
	Key: string;
	Value: string;
}

export interface IMetadataRequiredFields {
	Key: string;
	Name: string;
	Category: string;
}

export interface IMetadataResponseInterface extends IMetadataRequiredFields {
	Content: {
		ContentType: string;
		Data: string;
	};
	ContentType: string;
	UserId: string;
	Description: string;
	AuthorisationMode: 'Public' | 'Private';
	Timestamp: string;
	Attributes: IMetadataAttributes[];
}

export interface IAllMetadataResponseInterface extends IMetadataRequiredFields {
	UserId: string;
	MetadataVersionId: string;
	AuthorisationMode: 'Public' | 'Private';
	Timestamp: string;
	Attributes: IMetadataAttributes[];
	Title: string;
}

export interface IMetadataCreateResponse {
	Key: string;
	MetadataVersionId?: string;
}

export interface IMetadataRequestParams extends IMetadataCreateResponse {
	Category: string;
}

export interface ICreateMetadataRequestBody extends IMetadataRequiredFields {
	IsPublic?: boolean;
	Description?: string;
	Content: {
		ContentType: string;
		Data: string;
	};
	Attributes?: IMetadataAttributes[];
	AuthorisationMode?: 'Public' | 'Private';
	UserId?: string;
	Email?: string;
	Id?: string;
	CorrelatedRequestId?: string;
}

export interface IAllMetadataForUserRequest {
	Key: string;
	Category: string;
	AuthorisationMode?: 'Public' | 'Private';
	Page?: number;
	PageSize?: number;
	UserId?: string;
	Email?: string;
}

export const createMetadataRequest = (data: ICreateMetadataRequestBody) => {
	const url = config.metadata_service.create_metadata;

	return makeApiGatewayCall<IMetadataCreateResponse>(url, 'post', data);
};

export const createMetadataRequestOld = (data: ICreateMetadataRequestBody) => {
	const url = config.metadata_service_old.create_metadata;

	return makeApiGatewayCall<IMetadataCreateResponse>(url, 'post', data);
};

export const createMetadataVersionRequest = (data: ICreateMetadataRequestBody) => {
	const url = config.metadata_service.create_metadata_version(data.Key);

	return makeApiGatewayCall<IMetadataCreateResponse>(url, 'post', data);
};

export const createMetadataVersionRequestOld = (data: ICreateMetadataRequestBody) => {
	const url = config.metadata_service_old.create_metadata_version(data.Key);

	return makeApiGatewayCall<IMetadataCreateResponse>(url, 'post', data);
};

export const getLatestMetadataRequest = (params: IMetadataRequestParams, publicAccess?: IReportGridPublicAccess) => {
	const url = config.metadata_service.get_latest_metadata(params.Key, params.Category);

	const token = publicAccess?.accessTokens[3]; // ProxyGatewayAccessTokensEnum.Metadata
	if (publicAccess && token) {
		return makeApiProxyGatewayCall<IMetadataResponseInterface>(url, 'get', {
			'X-Jit': token,
			'X-Resource-Id': publicAccess.resourceId,
		});
	}

	return makeApiGatewayCall<IMetadataResponseInterface>(url, 'get');
};

export const getLatestMetadataRequestOld = (params: IMetadataRequestParams, publicAccess?: IReportGridPublicAccess) => {
	const url = config.metadata_service_old.get_latest_metadata(params.Key, params.Category);

	const token = publicAccess?.accessTokens[3]; // ProxyGatewayAccessTokensEnum.Metadata
	if (publicAccess && token) {
		return makeApiProxyGatewayCall<IMetadataResponseInterface>(url, 'get', {
			'X-Jit': token,
			'X-Resource-Id': publicAccess.resourceId,
		});
	}

	return makeApiGatewayCall<IMetadataResponseInterface>(url, 'get');
};

export const getAllMetaDataForUserOld = (category: string) => {
	const url = config.metadata_service_old.get_all_metadata_for_user(category);

	return makeApiGatewayCall<IAllMetadataResponseInterface[]>(url, 'get', {});
};

export const getAllMetaDataForUser = (category: string) => {
	const url = config.metadata_service.get_all_metadata_for_user(category);

	return makeApiGatewayCall<IAllMetadataResponseInterface[]>(url, 'get', {});
};

export const getAllMetaDataForUserByApiKey = (category: string, apiKey: string) => {
	const url = config.metadata_service.get_all_metadata_for_user(category);

	const requestConfig = {
		headers: {
			'X-ApiKey': apiKey,
		},
	};
	return makeApiGatewayCall(url, 'get');
};

export const deleteMetaData = (key: string, category: string) => {
	const params = `?Category=${category}`;

	const url = config.metadata_service.delete_metadata(key, params);

	return makeApiGatewayCall<boolean[]>(url, 'delete', {});
};

export const deleteMetaDataOld = (key: string, category: string) => {
	const params = `?Category=${category}`;

	const url = config.metadata_service_old.delete_metadata(key, params);

	return makeApiGatewayCall<boolean[]>(url, 'delete', {});
};
